import React, { useState } from "react";
import CardPreview from "../cardpreview/CardPreview";
import "./Card.css";
import { extractCardData } from "../../utils/cardData";

const Card = ({ card, onCardClick, animationDelay = 0 }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const isDoubleFaced = card.card_faces?.length === 2;

  const [showPreview, setShowPreview] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const { frontImage, backImage } = extractCardData(card);

  const handleMouseMove = (e) => {
    const offsetX = 20;
    const offsetY = 20;
    setMousePos({
      x: e.pageX + offsetX,
      y: e.pageY + offsetY,
    });
  };

  return (
    <div className="card-wrapper">
      <div
        className="card card-animated"
        style={{ animationDelay: `${animationDelay}ms` }}
        onClick={() => onCardClick(card)} // clicking card opens profile
        onMouseEnter={() => setShowPreview(true)}
        onMouseLeave={() => setShowPreview(false)}
        onMouseMove={handleMouseMove}
      >
        <div className={`card-inner ${isFlipped ? "flipped" : ""}`}>
          <div className="card-face front">
            <img src={frontImage} alt={card.name} />
          </div>
          {isDoubleFaced && (
            <div className="card-face back">
              <img src={backImage} alt={`${card.name} - back`} />
            </div>
          )}
        </div>

        {isDoubleFaced && (
          <img
            src={`${process.env.PUBLIC_URL}/cycle.png`}
            alt="Flip icon"
            className="card-flip-icon"
            onClick={(e) => {
              e.stopPropagation(); // prevents triggering card click for flip
              setIsFlipped(!isFlipped);
            }}
          />
        )}
      </div>

      {showPreview && (
        <CardPreview
          card={card}
          position={{ top: `${mousePos.y}px`, left: `${mousePos.x}px` }}
        />
      )}
      {/* logic for displaying card name if double sides */}
      {card.name.includes("//") ? (
        <p className="card-name">
          {card.name.split("//")[0].trim()}
          <br />
          <span className="card-name-secondary">
            {card.name.split("//")[1].trim()}
          </span>
        </p>
      ) : (
        <p className="card-name">{card.name}</p>
      )}
    </div>
  );
};

export default Card;
